/** Mirrors Masofa.BusinessLogic.CropMonitoring.PlanDataLock.PlanDataLockPolicies */
export const SEASON_PLAN_LOCKED_PAYLOAD_KEYS = [
  'title',
  'plannedCropId',
  'plannedVarietyId',
  'plantingDatePlan',
  'harvestingDatePlan',
  'yieldHaPlan',
  'yieldPlan',
  'fieldArea',
  'polygonJson',
  'cropConfirmationDate',
  'cropAgroExternalCropId',
  'seedGenerationId',
  'seedVarietyId',
  'isPlanned',
  'planDataSource',
  'planDataLockedAt',
] as const;

/** Planned sowing from external source — view-only in UI, no updates. */
export function isSeasonPlanned(season: Record<string, unknown> | null | undefined): boolean {
  return season?.['isPlanned'] === true;
}

/** Maps Season.planDataSource (enum int or name) to a translation key. */
export function resolvePlanDataSourceLabelKey(source: unknown): string | null {
  if (source === null || source === undefined) {
    return null;
  }
  if (source === 0 || source === '0' || source === 'CropAgro') {
    return 'SEASON_PLAN_DATA_SOURCE_CROP_AGRO';
  }
  return null;
}

export function isSeasonPlanDataLocked(season: Record<string, unknown> | null | undefined): boolean {
  if (!season) {
    return false;
  }

  if (season['isPlanned'] === true) {
    return true;
  }

  const planDataSource = season['planDataSource'];
  if (planDataSource !== null && planDataSource !== undefined) {
    return true;
  }

  const cropConfirmationSource = season['cropConfirmationSource'];
  if (
    typeof cropConfirmationSource === 'string' &&
    cropConfirmationSource.localeCompare('CropAgro', undefined, { sensitivity: 'accent' }) === 0
  ) {
    return true;
  }

  return season['cropAgroExternalCropId'] != null;
}

export function snapshotSeasonPlanLockedFields(
  season: Record<string, unknown>,
): Record<string, unknown> {
  const snapshot: Record<string, unknown> = {};

  for (const key of SEASON_PLAN_LOCKED_PAYLOAD_KEYS) {
    if (key === 'polygonJson') {
      snapshot['polygonJson'] = season['polygonJson'] ?? season['polygon'];
      continue;
    }
    snapshot[key] = season[key];
  }

  return snapshot;
}

export function applySeasonPlanLockedSnapshot(
  payload: Record<string, unknown>,
  snapshot: Record<string, unknown>,
): void {
  for (const key of SEASON_PLAN_LOCKED_PAYLOAD_KEYS) {
    if (Object.prototype.hasOwnProperty.call(snapshot, key)) {
      payload[key] = snapshot[key];
    }
  }
}
